(() => {
  document.querySelectorAll('[data-iv-model-alert]').forEach((element) => {
    if (element.dataset.initialized === 'true') return;
    element.dataset.initialized = 'true';
    const button = element.querySelector('[data-iv-model-alert-button]');
    const status = element.querySelector('[data-iv-model-alert-status]');
    if (!button || !status) return;
    button.addEventListener('click', async () => {
      if (button.disabled) return;
      button.disabled = true;
      status.textContent = element.dataset.loading;
      try {
        const productId = Number(element.dataset.productId);
        const variantId = Number(element.dataset.variantId);
        if (!Number.isSafeInteger(productId) || productId <= 0 || !Number.isSafeInteger(variantId) || variantId <= 0) throw new Error('Invalid model alert mapping');
        let api;
        for (let attempt = 0; attempt < 40; attempt += 1) {
          api = window._RestockRocket;
          if (typeof api?.openModal === 'function') break;
          await new Promise((resolve) => setTimeout(resolve, 200));
        }
        if (typeof api?.openModal !== 'function') throw new Error('Alert form unavailable');
        const product = {
          id: productId,
          title: element.dataset.modelTitle,
          variants: [{ id: variantId, title: 'Default Title', available: false }]
        };
        api.openModal(product, String(variantId));
        status.textContent = '';
      } catch {
        status.textContent = element.dataset.error;
      } finally {
        button.disabled = false;
      }
    });
  });
})();
